import { ProtectedPage } from "@/components/misc/protected";
import { createFileRoute } from "@tanstack/react-router";
import { ApiKeysPage } from "./-index/api-keys.page";

export const Route = createFileRoute("/api-keys/")({
  component: () => (
    <ProtectedPage requires="org:integrations_v2:read">
      <ApiKeysPage />
    </ProtectedPage>
  ),
});
